import React, { useEffect } from "react";
import styles from "./Modal.module.scss";
import Modal from "react-modal";
import { ModalProps } from "./types";
import { X } from "react-bootstrap-icons";
import Button from "../Button";

const GameModal: React.FC<ModalProps> = ({ isOpen, setOpen }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  // Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
  // useEffect(() => {
  //   const body = document.querySelector("body");
  //   Modal.setAppElement(body);
  // });

  function openModal() {
    setOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setOpen(false);
  }

  useEffect(() => {
    openModal();
  }, []);

  return (
    <div className={styles.modal}>
      <Modal
        isOpen={isOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <Button onClick={closeModal} className={styles.modal__close}>
          <X className={styles.modal__close__icon} />
        </Button>
        <div className={styles.modal__content}>
          <h1 className={styles.modal__content__title}>Instructions</h1>
          <div className={styles.modal__rules}>
            <p className={styles.modal__rules__text}>
              1: Press Start button to start a new game
            </p>
            <p className={styles.modal__rules__text}> 2: You have 60 seconds</p>
            <p className={styles.modal__rules__text}>
              3: Double click on each node to find the path between red and
              green nodes
            </p>
            <p className={styles.modal__rules__text}>
              4: Green is the start node
            </p>
            <p className={styles.modal__rules__text}>5: Red is the end node</p>
            <p className={styles.modal__rules__text}>6: Good Luck !!!</p>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default GameModal;
